import { ToasterClose } from '@icons'
import cn from '@integrations/classnames'
import { ToastBar, Toaster, toast } from '@integrations/notifications'
import { tr } from 'mmfintech-commons'
import styles from './CustomToaster.module.scss'

// react-hot-toast styles its bar with its own runtime classes, which no layered stylesheet can beat, so the bar's
// own properties are set inline from the variables the container declares in `app`.
function CustomToaster() {
  return (
    <Toaster
      gutter={10}
      containerClassName={cn(styles['custom-toaster-container'], 'custom-toaster-container')}
      position='top-right'
      containerStyle={{
        top: 'var(--toast-container-top)',
        zIndex: 'var(--toast-container-z-index)'
      }}
      toastOptions={{
        success: { iconTheme: { primary: 'var(--toast-icon-success)', secondary: 'var(--toast-icon-glyph)' } },
        error: { iconTheme: { primary: 'var(--toast-icon-error)', secondary: 'var(--toast-icon-glyph)' } }
      }}
    >
      {(t) => (
        <ToastBar
          toast={t}
          style={{
            display: 'var(--toast-display)',
            backgroundColor: 'var(--toast-bg)',
            borderRadius: 'var(--toast-radius)',
            boxShadow: 'var(--toast-shadow)',
            color: 'var(--toast-text)',
            fontSize: 'var(--toast-font-size)',
            lineHeight: 'var(--toast-line-height)',
            fontStyle: 'var(--toast-font-style)',
            padding: 'var(--toast-padding)',
            width: 'var(--toast-width)',
            maxWidth: 'var(--toast-max-width)'
          }}
        >
          {({ icon, message }) => (
            <div className={cn('custom-toaster')}>
              <div
                className={cn('icon')}
                // the icon is the only thing that says success or error, so it needs a text alternative
                {...(t.type === 'success' || t.type === 'error'
                  ? {
                      role: 'img',
                      'aria-label':
                        t.type === 'error'
                          ? tr('FRONTEND.COMMON.ERROR', 'Error')
                          : tr('FRONTEND.COMMON.SUCCESS', 'Success')
                    }
                  : {})}
              >
                {icon}
              </div>
              <div className={cn('content')}>{message}</div>
              {t.type !== 'loading' && (
                <button
                  type='button'
                  className={cn(styles['close-button'], 'close-button')}
                  aria-label={tr('FRONTEND.BUTTONS.CLOSE', 'Close')}
                  onClick={() => toast.dismiss(t.id)}
                >
                  <ToasterClose aria-hidden='true' />
                </button>
              )}
            </div>
          )}
        </ToastBar>
      )}
    </Toaster>
  )
}

export default CustomToaster
